<template>
  <base-message-box>
    <template slot="content">
      <slot>
        <p class="mb-2">
          Este pase <strong>sólo permite acceder a las instalaciones el tiempo necesario para acompañar al {{ name }}</strong>
          a la instalación donde realizará la actividad y <strong>deberá abandonarlas en cuanto finalice</strong>.
        </p>
      </slot>
      <p>
        <slot name="internal-regulations">
          El detalle de derechos y obligaciones de estos pases se puede consultar en el
          <a class="font-semibold underline hover:opacity-80" href="https://www.rgcc.es/system/cms_multimedia/cms_medias/files/000/011/374/original/N02_Reglamento_de_R%C3%A9gimen_Interno_Ed37.pdf?1624523057" target="_blank"> artículo 96 del Reglamento de Régimen Interno.</a>
        </slot>
      </p>
    </template>
  </base-message-box>
</template>

<script>

export default {
  name: 'WarningPoliciesPass',
  props: {
    name: {
      type: String,
      default: 'socio'
    }
  }
}
</script>

<style lang="scss" scoped></style>
